export class UpdateCesionRequest {
   cesionId: string;
   usuarioId: string;
   emisorId: string;
}
